export default __webpack_public_path__ + "static/media/bannervideo.2adfa6eb.mp4";